console.log('common');
// HTMLに特定の条件でクラスを付与していく
const htmlAddClass = () => {
  const html = document.documentElement;
  // const docHeight = document.body.clientHeight;

  // ロード完了時（.3秒で）is-load付与
  setTimeout(function () {
    html.classList.add('is-load');
  }, 300);

  let startPos = 0;
  let winScrollTop = 0;
  // start,end付与時のマージン
  const triggerMargin = 100;
  const scrollFlgP = 800;
  // スクロール時
  window.addEventListener('scroll', function () {
    winScrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    // down up 付与
    if (winScrollTop >= startPos) {
      html.classList.remove('scroll-up');
      html.classList.add('scroll-down');
    } else {
      html.classList.remove('scroll-down');
      html.classList.add('scroll-up');
    }
    // スクロールスタート付与
    if (winScrollTop >= triggerMargin) {
      html.classList.add('scroll-start');
    } else {
      html.classList.remove('scroll-start');
    }
    // scroll-fv
    if (winScrollTop >= scrollFlgP) {
      html.classList.add('scroll-fv');
    } else {
      html.classList.remove('scroll-fv');
    }
    // console.log(winScrollTop);
    // スクロールエンド付与
    const allHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight
    );
    const mostBottom = allHeight - window.innerHeight;
    const scrollTopL = winScrollTop + 1;
    if (scrollTopL >= mostBottom) {
      html.classList.add('scroll-end');
    } else {
      html.classList.remove('scroll-end');
    }

    startPos = winScrollTop;
  });
};
htmlAddClass();
